import * as $ from "jquery"

export default function ReviewUtils() {
  // Hide all feedback bubbles on ESC
  $("body").on("keydown", e => {
    if (e.keyCode === 27) {
      window.dispatchEvent(new CustomEvent("hideFeedbackContainers"))
    }
  })
}
